import React, { useCallback, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import classnames from 'classnames';

import Reports from '../Reports';

const holdingsMenuLinks = [
  { href: '/holdings', label: 'Beholdning og ordre' },
  { href: '/holdings/fictive-portfolios', label: 'Fiktiv portefølje' },
  { href: '/holdings/search/orders', label: 'Ordresøk' },
  { href: '/holdings/search/transactions', label: 'Sluttseddelsøk' },
];

const menuLinks = [
  { href: '/overview', label: 'Oversikt' },
  { href: '/holdings', label: 'Beholdning og ordre' },
  { href: '/lists/shares', label: 'Kurslister' },
  { href: '/analysis', label: 'Analyser' },
  { href: '/news', label: 'Børsmeldinger' },
  { href: '/tdn-news', label: 'TDN Nyheter' },
  { href: '/calendar', label: 'Finanskalender' },
  {
    href: '/faq',
    label: (
      <>
        FAQ og support <i className="hb-question-mark-rounded" />
      </>
    ),
    className: 'faq',
  },
];

const premiumMenuLinks = [
  { href: '/premium/overview', label: 'Oversikt', printable: true },
  { href: '/premium/faq', label: 'Kontakt oss' },
];

const Links = ({ links = [], exactMatch = [] }) => {
  return links.map(({ href, label, className }) => (
    <li key={label} className={className}>
      <NavLink exact={exactMatch.includes(href)} to={href}>
        {label}
      </NavLink>
    </li>
  ));
};

const HeaderMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { location } = useHistory();
  const pathname = location.pathname;

  const btnClasses = classnames('btn', 'btn-hamburger', isOpen && 'open');
  const links = pathname.startsWith('/premium') ? premiumMenuLinks : menuLinks;

  const currentLocationIsPrintable = links.some(
    link => link.href === pathname && link.printable,
  );

  const toggleNav = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const closeNav = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <nav role="navigation">
      <button type="button" className={btnClasses} onClick={toggleNav}>
        <span />
        <span />
        <span />
      </button>
      <div className="visible-xs">
        <Reports />
      </div>
      <ul
        data-test-id="menu-link"
        onClick={closeNav}
        className={`navigation-menu ${isOpen && 'open'}`}
      >
        <Links links={links} />
        {currentLocationIsPrintable && (
          <li className="faq">
            <button className="print-button" onClick={() => window.print()}>
              Skriv ut
              <span className="fa fa-print" aria-hidden="true" />
            </button>
          </li>
        )}
      </ul>
      {pathname.startsWith('/holdings') && (
        <ul
          data-test-id="submenu-link"
          onClick={closeNav}
          className="navigation-submenu"
        >
          <Links links={holdingsMenuLinks} exactMatch={['/holdings']} />
        </ul>
      )}
    </nav>
  );
};

export default HeaderMenu;
